import { useMemo, useRef } from "react";
import { Link } from "react-router-dom";
import { ProductCard } from "../../../components/base/ProductCard";
import { useProducts } from "../../../hooks/useProducts";

const isTruthyValue = (value: any): boolean => {
  return value === true || value === 1 || value === "1" || value === "true";
};

const categoryMatches = (categories: any, slug: string): boolean => {
  if (Array.isArray(categories)) {
    return categories.some((item) => String(item).trim() === slug);
  }

  if (typeof categories === "string") {
    return categories
      .split(",")
      .map((item) => item.trim())
      .includes(slug);
  }

  return false;
};

export default function NewInSection() {
  const { products } = useProducts();
  const scrollRef = useRef<HTMLDivElement | null>(null);

  const conjunto2Pecas = useMemo(() => {
    return (products || []).filter((product: any) => {
      const isVisible = isTruthyValue(product?.visible);
      const isInCategory = categoryMatches(product?.categories, "conjunto-2-pecas");
      return isVisible && isInCategory;
    });
  }, [products]);

  const scrollCarousel = (direction: "left" | "right") => {
    if (!scrollRef.current) return;
    const container = scrollRef.current;
    const amount = container.clientWidth * 0.8;
    container.scrollBy({ left: direction === "left" ? -amount : amount, behavior: "smooth" });
  };

  return null;

  if (conjunto2Pecas.length === 0) return null;

  return (
    <section className="py-14 px-4 md:px-8 bg-[#FAF8F5]">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex items-center justify-between mb-10">
          <div className="flex items-center gap-4 flex-1">
            <div className="flex-1 h-px bg-black/10" />
            <h2 className="text-[13px] tracking-[0.3em] font-semibold text-black uppercase whitespace-nowrap">
              Novos Conjuntos 2 Peças
            </h2>
            <div className="flex-1 h-px bg-black/10" />
          </div>

          <div className="flex items-center gap-2 ml-6 flex-shrink-0">
            <button
              type="button"
              onClick={() => scrollCarousel("left")}
              className="w-9 h-9 border border-black/20 flex items-center justify-center text-black hover:bg-black hover:text-white transition-all cursor-pointer"
              aria-label="Voltar"
            >
              <i className="ri-arrow-left-s-line text-lg" />
            </button>
            <button
              type="button"
              onClick={() => scrollCarousel("right")}
              className="w-9 h-9 border border-black/20 flex items-center justify-center text-black hover:bg-black hover:text-white transition-all cursor-pointer"
              aria-label="Avançar"
            >
              <i className="ri-arrow-right-s-line text-lg" />
            </button>
            <Link
              to="/categoria/conjunto-2-pecas"
              className="hidden md:inline text-[10px] tracking-[0.18em] text-black/50 hover:text-black border-b border-black/20 hover:border-black transition-all pb-0.5 whitespace-nowrap ml-2"
            >
              VER TUDO
            </Link>
          </div>
        </div>

        <div
          ref={scrollRef}
          className="flex gap-4 overflow-x-auto snap-x snap-mandatory scroll-smooth pb-2 [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden"
          data-product-shop
        >
          {conjunto2Pecas.map((product: any) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </div>
    </section>
  );
}
